import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { NSUrlsConstants } from '@ruby/configs/urls.constants';
import { IOrderFill, IOrderFillDateRange, IOrderFillLocation, IOrderFillPattern, IOrderFillRequest } from '@ruby/modules/order-fill/model/order-fill.interface';
import { EOrderFillDateType } from '@ruby/shared/enums/order-fill.enums';

@Injectable({
  providedIn: 'root'
})
export class OrderFillService {

  constructor(private http: HttpClient) { }

  /**
   * Get Summary
   *
   * @summary Gets summary details
   * @param payload: IOrderFillRequest
   * @returns Observable<IOrderFill | never>
   */
  getSummary(payload: IOrderFillRequest): Observable<IOrderFill | never> {
    return this.http.post(NSUrlsConstants.orderFillUrl, payload).pipe(map(response => response as IOrderFill));
  }

  /**
   * Get Locations
   *
   * @summary Get locations details
   * @param primary6: string
   * @returns Observable<Array<IOrderFillLocation> | never>
   */
  getLocations(primary6: string): Observable<Array<IOrderFillLocation> | never> {
    return this.http.get(`${ NSUrlsConstants.orderFillUrl }/locations/primary6/${ primary6 }`)
      .pipe(map(response => response as Array<IOrderFillLocation>));
  }

  /**
   * Get Patterns
   *
   * @summary Get list of patterns
   * @param locationsIds: Array<string>
   * @returns Observable<Array<IOrderFillPattern> | never>
   */
  getPatterns(locationsIds: Array<string>): Observable<Array<IOrderFillPattern> | never> {
    return this.http.post(`${ NSUrlsConstants.orderFillUrl }/patterns`, locationsIds)
      .pipe(map(response => response as Array<IOrderFillPattern>));
  }

  /**
   * Get Date Range
   *
   * @summary Get date range
   * @param dateRangeType: EOrderFillDateType
   * @returns Observable<IOrderFillDateRange | never>
   */
  getDateRange(dateRangeType: EOrderFillDateType): Observable<IOrderFillDateRange | never> {
    return this.http.get(`${ NSUrlsConstants.orderFillUrl }/date-range/${ dateRangeType }`)
      .pipe(map(response => response as IOrderFillDateRange));
  }
}
